import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {Title, Meta} from '@angular/platform-browser';

@Component({
  selector: 'app-privacy-policy',
  imports: [
    RouterLink
  ],
  templateUrl: './privacy-policy.html',
  styleUrl: './privacy-policy.scss'
})
export class PrivacyPolicy implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) {}

  ngOnInit(): void {
    this.titleService.setTitle('Privacy Policy | FlashDrivePrices');
    this.metaService.addTag({ name: 'description', content: 'This Privacy Policy explains how FlashDrivePrices.com collects, uses, and protects your information.' });
  }
}
